
<span :class="{ active: isAnimated }" class="bouton-copier" @click="copyText">
  <svg-icon
    aria-label="Copier"
    class="icon-copier svg-icon-big mr-0 mt-0"
    icon-name="icon-copier"
  ></svg-icon>
  <svg-icon
    aria-label="Succès"
    class="icon-copier-ok svg-icon-big mr-0 mt-0"
    icon-name="icon-copier-ok"
  ></svg-icon>
</span>
